import { CustomFieldsSection } from "./sections/hero/CustomFieldsSection";
import { HeroFinalSyncSection } from "./sections/hero/HeroFinalSyncSection";
import { HeroOutboundControlSection } from "./sections/hero/HeroOutboundControlSection";
import { TravelKmSection } from "./sections/hero/RateMappingSections";
import { HeroStepActionMatrix } from "./sections/hero/HeroStepActionMatrix";
import { InvoiceTextsSection } from "./sections/hero/InvoiceTextsSection";
import { useSettingsAcl } from "./lib/useSettingsAcl";
import { SettingsAccessDenied } from "./SettingsLayout";

export function HeroPage() {
  const acl = useSettingsAcl();

  if (acl.loading) return null;
  if (!acl.canAuftraege) return <SettingsAccessDenied />;

  return (
    <div className="space-y-6">
      <HeroOutboundControlSection />
      <HeroFinalSyncSection />
      <CustomFieldsSection />
      <TravelKmSection />
      <HeroStepActionMatrix />
      <InvoiceTextsSection />
    </div>
  );
}
